import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMatrixComponent } from './simple-icons-matrix.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMatrixComponent ],
    exports:      [ SimpleIconsMatrixComponent ],
    bootstrap:    []
})
export class SimpleIconsMatrixModule {}
